import { theme, GlobalStyles } from '@taxbit-private/cosmic'
import { createGlobalStyle, ThemeProvider } from 'styled-components'

/**
 * Inject the global background color we want for the accounting app in addition
 * to the other global styles that Cosmic offers. This has to live at the top
 * to avoid a Typescript error about declaration ordering.
 */
const AccountingGlobalStyles = createGlobalStyle(
  ({ theme }) => `
  html, body, #root {
    height: 100%;
  }

  body {
    background-color: ${theme.color.gray0};
    font-family: "Avenir", "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 300;
    line-height: 1.42857;
  }

  /* Remove underlines from links */
  a {
    text-decoration: none;
  }

  /* Maintain current application letter spacing */
  * {
    letter-spacing: normal !important;
  }
`
)

const CosmicThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <AccountingGlobalStyles />
      {children}
    </ThemeProvider>
  )
}

export default CosmicThemeProvider
